import { render, staticRenderFns } from "./inscritos.vue?vue&type=template&id=4f80c9f7"
import script from "./inscritos.vue?vue&type=script&lang=js"
export * from "./inscritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports